import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Button from "../common/button/button";

import {
  setModoTela,
  getLista,
  setCadastroCorrigido,
} from "./erroIntegracaoActions";

class ErroIntegracao extends Component {
  state = {
    tipo: "SÓCIO",
    tipo_erro: "DADOS_INVALIDOS_BD_SINDICATO",
  };

  componentWillMount() {
    this.props.getLista(this.state);
  }

  render() {
    const isMobile = window.innerWidth <= 768;

    const exibirBotaoReenviar =
      ["SÓCIO", "CONJUGE"].includes(this.state.tipo) &&
      this.state.tipo_erro == "DADOS_INVALIDOS_BD_SINDICATO";

    return (
      <ContentCard>
        <Row style={{ margin: 10 }}>
          <Grid cols="12 12 4 4">
            <select
              className="form-control"
              onChange={(e) => {
                this.setState({ ...this.state, tipo: e.target.value });
              }}
            >
              <option value="SÓCIO" selected>
                Sócio
              </option>
              <option value="CONJUGE">Conjuge</option>
              <option value="MENSALIDADE">Mensalidade</option>
            </select>
          </Grid>
          <Grid cols="12 12 4 4" style={{ marginBlock: isMobile ? 10 : 0 }}>
            <select
              className="form-control"
              onChange={(e) => {
                this.setState({ ...this.state, tipo_erro: e.target.value });
              }}
            >
              <option value="DADOS_INVALIDOS_BD_SINDICATO" selected>
                Cadastro no sindicato com dados inválidos
              </option>
              <option value="ERRO_API_FETAG">
                Erro ao enviar para a FETAG
              </option>
              <option value="ERRO_CONSULTA_BD_SINDICATO">
                Erro ao consultar os dados no sindicato
              </option>
            </select>
          </Grid>
          <Grid
            cols="12 12 4 4"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              solid={true}
              text="Buscar"
              title="Enviar para a FETAG"
              type={"primary"}
              icon={"fa fa-search"}
              event={() => {
                this.props.getLista(this.state);
              }}
            />
          </Grid>
        </Row>
        <ContentCardBody>
          <Table responsive>
            <THead>
              <Tr>
                <Th
                  colspan={2}
                  paddingBottom={10}
                  paddingTop={20}
                  paddingLeft={20}
                >
                  Motivo do Erro
                </Th>

                <Th colspan={1} paddingBottom={10} paddingTop={20}></Th>
              </Tr>
            </THead>
            <TBody>
              {this.props.lista.map((item, index) => {
                const actionReenviar = () => {
                  if (
                    !window.confirm(
                      "O cadastro será marcado como corrigido e uma nova tentativa de envio será realizada a partir do cadastro corrigido. Deseja continuar?",
                    )
                  )
                    return;
                  this.props.setCadastroCorrigido({
                    item,
                    callback: () => this.props.getLista(this.state),
                  });
                };

                return (
                  <Tr
                    key={item.id}
                    className={`${this.state.linhaSelecionada == index ? "hover" : ""}`}
                  >
                    <Td paddingLeft={20}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          maxWidth: isMobile ? "95vw" : "60vw",
                        }}
                      >
                        {isMobile
                          ? exibirBotaoReenviar && (
                              <Button
                                style={{ width: "90%", marginBlock: 10 }}
                                solid={true}
                                text="Foi Corrigido, quero REENVIAR"
                                title="Define o cadastro como corrigido"
                                type={"success"}
                                event={actionReenviar}
                              />
                            )
                          : null}

                        <div
                          style={{
                            fontWeight: "bold",
                            display: "flex",
                            paddingTop: 10,
                          }}
                        >
                          <span className="pr-1">
                            Data/Hora que tentou enviar:
                          </span>
                          {item.data_hora
                            ? new Date(item.data_hora)
                                .toLocaleString({
                                  dateStyle: "short",
                                  timeStyle: "medium",
                                })
                                .replace(",", "")
                            : " - "}
                        </div>
                        <p style={{ marginBlocl: 10, color: "#e61643" }}>
                          {item.motivo}
                        </p>
                        <pre style={{ margin: 0 }}>
                          {JSON.stringify(
                            JSON.parse(item.registro_com_erro),
                            null,
                            4,
                          )}
                        </pre>
                      </div>
                    </Td>
                    <Td>
                      {isMobile
                        ? null
                        : exibirBotaoReenviar && (
                            <Button
                              style={{ width: 150 }}
                              solid={true}
                              text="Foi Corrigido, quero REENVIAR"
                              title="Define o cadastro como corrigido"
                              type={"success"}
                              event={actionReenviar}
                            />
                          )}
                    </Td>
                  </Tr>
                );
              })}
            </TBody>
          </Table>
        </ContentCardBody>
      </ContentCard>
    );
  }
}

const mapStateToProps = (state) => ({
  modoTela: state.erroIntegracao.modoTela,
  lista: state.erroIntegracao.lista,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setModoTela, getLista, setCadastroCorrigido }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ErroIntegracao);
